/**
 * Gestisce la visibilità del testo nei campi password.
 * Attiva i toggle .show-password / .hide-password presenti nel DOM.
 */
export function initShowHidePassword(): void {
    document.querySelectorAll<HTMLElement>('.show-password, .hide-password').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const input = toggle.parentElement?.querySelector<HTMLInputElement>('input');
            if (!input) return;

            const isShowBtn = toggle.classList.contains('show-password');

            input.type = isShowBtn ? 'text' : 'password';

            toggle.classList.toggle('show-password', !isShowBtn);
            toggle.classList.toggle('hide-password',  isShowBtn);

            const icon = toggle.firstElementChild;
            if (icon) icon.textContent = isShowBtn ? 'visibility' : 'visibility_off';
        });
    });
}
